import React from 'react';
import { useTranslation } from "next-i18next";
import { alpha, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";

import Container from "../../Common/Container";
import importAll from "../../../lib/utils/image";
import CloudinaryImage from '../../Common/CloudinaryImage';

const images = importAll(
  require.context(
    "../../../public/static/images/features/pictos/",
    false,
    /\.(png|jpe?g|svg)$/
  )
);

const mapImage = (name) => {
  return images[`${name}.png`];
};

const ExtraFeatures = () => {
  const { t } = useTranslation("features");
  const theme = useTheme();

  return (
    <Container>
      <Box
        component={Typography}
        marginBottom={4}
        fontWeight={700}
        variant={"h3"}
        mb={10}
        align={"center"}
      >
        {t("extra_features_title")}
      </Box>
      <Box>
        <Grid container spacing={4}>
          {t("extra_features", { returnObjects: true }).map((item, i) => (
            <Grid item xs={12} sm={6} md={3} key={i} data-aos={"fade-up"}>
              <Box display={"flex"} flexDirection={"column"}>
                <Box
                  component={Avatar}
                  variant="rounded"
                  width={72}
                  height={72}
                  marginBottom={2}
                  bgcolor={alpha(theme.palette.primary.main, 0.1)}
                  borderRadius={3}
                >
                  <CloudinaryImage
                    src={mapImage(item.icon)}
                    alt={`${item.title} icon`}
                    width={72}
                    height={72}
                    placeholder="blur"
                  />
                </Box>
                <Typography variant={"h6"} component="h4" gutterBottom fontWeight={500}>
                  {item.title}
                </Typography>
                <Typography color="text.secondary">{item.subtitle}</Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default ExtraFeatures;
